import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ArrowDownTray({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M13.0554 10.4443V11.7777C13.0554 12.7599 12.2599 13.5554 11.2777 13.5554H3.72211C2.73989 13.5554 1.94434 12.7599 1.94434 11.7777V10.4443"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.38892 6L7.50003 9.11111L10.6111 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.111V2.44434"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
